/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktsFromIdResponseItems
 */
export interface GetAktsFromIdResponseItems {
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdResponseItems
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdResponseItems
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    subject: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktsFromIdResponseItems
     */
    isBold: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    resp: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdResponseItems
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktsFromIdResponseItems
     */
    hasattachment: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    aktname: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdResponseItems
     */
    akttype: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdResponseItems
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdResponseItems
     */
    todotype: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktsFromIdResponseItems
     */
    isrecurring?: boolean;
}

export function GetAktsFromIdResponseItemsFromJSON(json: any): GetAktsFromIdResponseItems {
    return GetAktsFromIdResponseItemsFromJSONTyped(json, false);
}

export function GetAktsFromIdResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktsFromIdResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'aktid': json['aktid'],
        'date': json['date'],
        'subject': json['subject'],
        'isBold': json['isBold'],
        'icon': json['icon'],
        'color': json['color'],
        'resp': json['resp'],
        'priority': json['priority'],
        'hasattachment': json['hasattachment'],
        'aktname': json['aktname'],
        'akttype': json['akttype'],
        'summary': json['summary'],
        'todotype': json['todotype'],
        'isrecurring': !exists(json, 'isrecurring') ? undefined : json['isrecurring'],
    };
}

export function GetAktsFromIdResponseItemsToJSON(value?: GetAktsFromIdResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'aktid': value.aktid,
        'date': value.date,
        'subject': value.subject,
        'isBold': value.isBold,
        'icon': value.icon,
        'color': value.color,
        'resp': value.resp,
        'priority': value.priority,
        'hasattachment': value.hasattachment,
        'aktname': value.aktname,
        'akttype': value.akttype,
        'summary': value.summary,
        'todotype': value.todotype,
        'isrecurring': value.isrecurring,
    };
}


